export const SIGNATURE_ROLE = {
  CARRIER: {
    KEY: 'carrier',
    STRING: 'Spediteur',
  },
  ON_BEHALF_CARRIER: {
    KEY: 'onBehalfCarrier',
    STRING: 'Spediteur',
  },
  ON_BEHALF_RECIPIENT: {
    KEY: 'onBehalfRecipient',
    STRING: 'Abnehmer',
  },
  ON_BEHALF_SUPPLIER: {
    KEY: 'onBehalfSupplier',
    STRING: 'Lieferant',
  },
  RECIPIENT: {
    KEY: 'recipient',
    LEGACY_KEY: 'buyer',
    STRING: 'Abnehmer',
  },
  SUPPLIER: {
    KEY: 'supplier',
    STRING: 'Lieferant',
  },
} as const;
